export default __webpack_public_path__ + "static/media/HermosoOpen.963856d3.jpg";